import register from '../../../../global/js/registry';
export default register('o-mediacenter-list', () => import(/* webpackMode: "lazy" */ './o-mediacenter-list.controller'));
